module.exports = __webpack_public_path__ + "img/ic_yao_bong.d2ef21f8.png";